
import { useEffect, useState } from 'react'
import './style.scss'
import '../styles/admintab.scss'
import { useAppSelector } from '../../redux/hooks'
import { UserData } from '../../server/types'
import { getProfilePicPath } from '../../constants/instructorConstants'
import { PAGE_URLS } from '../../constants/hrefLinks'
import { adminStateData } from '../../data/adminStateData'
import { AccountStatus } from '../../types/types'

function AdminInstructorsContentArea() {
	const [tabIndex, setTabIndex] = useState<number>(0)
	const [instructors, setInstructors] = useState<UserData[]>([])
	const [adminDataLoaded, setAdminDataLoaded] = useState<boolean>(false)

	const dataLoadRequestFinished: boolean = useAppSelector(state => state.user.dataLoadRequestFinished)

	const INSTRUCTOR_TABS: string[] = ['All', 'Active', 'Incomplete', 'Verifying Email', 'Awaiting Doc', 'Doc Review', 'Flagged', 'Banned', 'Disabled']
	const TAB_STATUSES: string[] = ['', AccountStatus.ACTIVE, AccountStatus.INCOMPLETE, AccountStatus.VERIFY_EMAIL, AccountStatus.CERTIFICATE_NOT_PROVIDED, AccountStatus.CERTIFICATE_UNDER_REVIEW, AccountStatus.FLAGGED, AccountStatus.BANNED, AccountStatus.DISABLED]

	useEffect(() => {
		if (dataLoadRequestFinished === true) {
			setAdminDataLoaded(true)
			setInstructors(adminStateData.getInstructors())
			setTabIndex(0)
		}
	}, [dataLoadRequestFinished])

	const tabClickHandler = (newIndex: number) => {
		if (newIndex === 0) {
			setInstructors(adminStateData.getInstructors())
		} else {
			setInstructors(adminStateData.getInstructorsWithStatus(TAB_STATUSES[newIndex]))
		}
		setTabIndex(newIndex)
	}

	return (
		<div className='dashboard-content-area-wrap'>
			{adminDataLoaded &&
				<div className='dashboard-content-area-wide-card-wrap'>
					<div className='dashboard-content-area-card'>
						<div className='admin-tab-wrap'>
							{INSTRUCTOR_TABS.map((tab: string, index: number) => 
								<div 
									className={`admin-tab-item ${tabIndex === index ? 'admin-tab-item-active' : ''}`}
									key={`tablabel${index}`}
									onClick={() => tabClickHandler(index)}
								>{tab}</div>
							)}
						</div>
						<div
							className='dashboard-content-area-card-content'
						>
							{
							instructors.length === 0 ?
								<span>No Instructors</span>
								:
								instructors.map((instructor: UserData, index: number) => 
									<a 
										className='dashboard-user-list-wrap'
										key={`instructorItem${index}`}
										href={`${PAGE_URLS.ADMIN_INSTRUCTOR}?id=${instructor.id}`}
									>
										<img
											className='dashboard-user-list-img'
											alt='profile thumbnail'
											src={instructor?.profile_pics ? getProfilePicPath(instructor?.profile_pics, 0) : undefined}
										/>
										<div className='dashboard-user-list-details-wrap'>
											<div className='dashboard-user-list-name'>{instructor?.name}</div>
											<div className='dashboard-user-list-extract'>{instructor?.email}</div>
										</div>
										<div className={`dashboard-admin-status dashboard-admin-status-${instructor?.status.toLowerCase()}`}>{instructor?.status}</div>
										{/* {instructor?.status === 'FLAGGED' &&
											<div className='dashboard-admin-status dashboard-admin-status-flagged'>Flagged</div>
										}
										{instructor?.status === AccountStatus.CERTIFICATE_UNDER_REVIEW &&
											<div className='dashboard-admin-status dashboard-admin-status-doc-review'>Doc Review</div>
										} */}
									</a>
								)
							}
						</div>
					</div>
				</div>
			}
		</div>
	)
}

export default AdminInstructorsContentArea
